/* eslint-disable react/prop-types */
import React from 'react';
import { AlertCircle } from '@nike/nike-design-system-icons';
import { TextStyled } from '@nike/nike-design-system-components';

import ToolTip from '../../components/ToolTip';

import ColumnFilterSort from '../../components/tableServerSide/ColumnFilterSort';

import { formatDateTimestamp } from '../../util/date';
import { getOrderTypeLabel } from '../catalogs/constants';

const paymentMethods = {
  'COMP-CASH': 'Comp',
  'COMP-UNIT': 'Unit',
  BILLABLE: 'Billable'
};

export const columnSortModifiersOrderIssues = {
  defaultSort: { createTimestamp: 'desc' }
};

export const columnFilterModifiersOrderIssues = {
  createTimestamp: { disabled: true },
  orderStatus: { value: input => input.toUpperCase() },
  accountName: { expression: 'Like', value: input => input.toUpperCase() },
  departmentName: { expression: 'Like', value: input => input.toUpperCase() },
  purchaseOrderNumber: { expression: 'Like' },
  purchaseMethod: {
    value: input => {
      const formattedInput = input.toLowerCase();
      switch (formattedInput) {
        case 'comp':
          return 'COMP-CASH';
        case 'unit':
          return 'COMP-UNIT';
        case 'billable':
          return 'BILLABLE';
        default:
          return input;
      }
    }
  }
};

export const getOrderIssueColumns = ({ handleOpenLineItemsModal }) => {
  return [
    {
      Header: tableInstance => <ColumnFilterSort header='Date Submitted' tableInstance={tableInstance} align='right' />,
      accessor: 'createTimestamp',
      width: 165,
      Cell: ({ value }) => formatDateTimestamp(value)
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Order Type' tableInstance={tableInstance} />,
      width: 120,
      accessor: 'orderType',
      Cell: ({ value }) => getOrderTypeLabel(value)
    },
    {
      Header: tableInstance => (
        <ColumnFilterSort
          header='Order Status'
          tableInstance={tableInstance}
          searchHelperText='SUBMITTED or FAILED Only'
        />
      ),
      width: 120,
      accessor: 'orderStatus',
      Cell: ({ row }) =>
        row.original.errorMessage ? (
          <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between' }}>
            <span>{row.original.orderStatus}</span>
            <ToolTip
              title={
                <TextStyled appearance='body2' bold>
                  {row.original.errorMessage}
                </TextStyled>
              }
              className='orderErrorTooltip'
            >
              <AlertCircle size='s' />
            </ToolTip>
          </div>
        ) : (
          <span>{row.original.orderStatus}</span>
        )
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Account Number' tableInstance={tableInstance} />,
      width: 150,
      accessor: 'accountNumber'
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Account Name' tableInstance={tableInstance} />,
      width: 200,
      accessor: 'accountName'
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Department Name' tableInstance={tableInstance} />,
      width: 200,
      accessor: 'departmentName'
    },
    {
      Header: tableInstance => <ColumnFilterSort header='PO Number' tableInstance={tableInstance} />,
      width: 200,
      accessor: 'purchaseOrderNumber'
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Payment Type' tableInstance={tableInstance} />,
      width: 130,
      accessor: 'purchaseMethod',
      Cell: ({ value }) => paymentMethods[value] || value
    },
    {
      Header: 'Line Items',
      accessor: 'orderId',
      width: 200,
      Cell: ({ value }) => (
        <div onClick={() => handleOpenLineItemsModal(value)} style={{ cursor: 'pointer' }}>
          <TextStyled appearance='body2Link'>View Order Line Items</TextStyled>
        </div>
      )
    },
    {
      Header: 'Link to Now',
      accessor: 'ofoaId',
      width: 300,
      // eslint-disable-next-line react/prop-types
      Cell: ({ value }) =>
        value && (
          <a
            // eslint-disable-next-line max-len
            href={`${import.meta.env.VITE_OSD_NOW_URL}/purchase-order/ofoaId=${value}`} // eslint-disable-line react/prop-types
            target='_blank'
            rel='noopener noreferrer'
            style={{ color: '#3498db', textDecoration: 'underline' }}
          >
            {value}
          </a>
        )
    }
  ];
};
